var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.001,
    height: 24.94,
    viewBox: "0 0 25.001 24.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin_1_",
    "data-name": "linkedin (1)",
    transform: "translate(0.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M7.787,15.941h5.188V32.6H7.787ZM10.381,7.66a3.065,3.065,0,1,0,.051,0",
    transform: "translate(-7.38 -7.66)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M16.07,15.808h5.016v2.238h0a5.443,5.443,0,0,1,4.9-2.7c5.239,0,6.206,3.449,6.206,7.935v9.156H27.047V24.3c0-1.933,0-4.415-2.7-4.415s-3.1,2.106-3.1,4.273V32.4H16.07Z",
    transform: "translate(-7.229 -7.526)",
    fill: "#a6a6a6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGrey);
export default __webpack_public_path__ + "static/media/link-grey.c63b8dae0570268fc8b6f8c0766d04fc.svg";
export { ForwardRef as ReactComponent };